/**
 * @generated SignedSource<<ed1a091f6bf24436163dc492a4c7d75c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedCreatorsRootHeadingsWrapper_itemSearch$data = {
  readonly meta: {
    readonly subHeader: string | null;
  } | null;
  readonly " $fragmentType": "SharedCreatorsRootHeadingsWrapper_itemSearch";
};
export type SharedCreatorsRootHeadingsWrapper_itemSearch$key = {
  readonly " $data"?: SharedCreatorsRootHeadingsWrapper_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedCreatorsRootHeadingsWrapper_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedCreatorsRootHeadingsWrapper_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subHeader",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "54b27cdae2c3c2ba48aaf7a20d4c8264";

export default node;
